import { AssetConfig } from "../index";

export const VehicleGroupAssetConfig: AssetConfig = {
    name: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
    description: {type: "STRING",required: true,editable: true,label: "Description",rank: 2},
}